// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../resources/homepage/fold6_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sectionSix-wrapper {
  display: flex;
  width: 100%;
  flex-direction: column;
  background: #fff;
}
#sectionSix-wrapper #sectionSix {
  padding: 80px 0 0;
}
#sectionSix-wrapper #sectionSix #sectionSix-head {
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 43px;
  line-height: 50.39px;
  color: #1c2640;
  text-align: center;
  margin: 0 0 80px;
  padding: 0;
}
#sectionSix-wrapper #sectionSix .sectionSix-sub-head {
  font-family: Roboto;
  font-size: 20px;
  font-weight: 400;
  line-height: 15px;
  text-align: center;
  color: #52667C;
  margin-top: -60px;
  margin-bottom: 50px;
}
#sectionSix-wrapper #sectionSix .sectionSix-content {
  height: 650px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat bottom right;
  background-size: 100%;
}
#sectionSix-wrapper #sectionSix .sectionSix-content #sectionSix-left-middle {
  display: flex;
  flex-direction: row;
  padding: 10px 110px;
  width: 50%;
}
#sectionSix-wrapper #sectionSix .sectionSix-content #sectionSix-left-middle-left {
  text-align: left;
  padding-right: 3%;
  border-right: unset !important;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  color: #1c2640;
  padding-right: 100px;
}
#sectionSix-wrapper #sectionSix .sectionSix-content #sectionSix-left-middle-left ul.list-delivers {
  margin: 0;
  list-style-type: none;
}
#sectionSix-wrapper #sectionSix .sectionSix-content #sectionSix-left-middle-left ul.list-delivers li {
  margin-top: 20px;
  display: flex;
}
#sectionSix-wrapper #sectionSix .sectionSix-content #sectionSix-left-middle-left ul.list-delivers li .check-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-top: 7.5px;
}`, "",{"version":3,"sources":["webpack://./src/components/Home/SectionSix/sectionSix.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;AACJ;AACI;EACI,iBAAA;AACR;AACQ;EACI,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AACZ;AACQ;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AACZ;AACQ;EACI,aAAA;EACA,0EAAA;EAEA,qBAAA;AAAZ;AAEY;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;AAAhB;AAGY;EACI,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;AADhB;AAGgB;EACI,SAAA;EACA,qBAAA;AADpB;AAEoB;EACI,gBAAA;EACA,aAAA;AAAxB;AAEwB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAA5B","sourcesContent":["#sectionSix-wrapper {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    background: #fff;\n\n    #sectionSix{\n        padding: 80px 0 0;\n\n        #sectionSix-head {\n            font-family: Roboto;\n            font-style: normal;\n            font-weight: 600;\n            font-size: 43px;\n            line-height: 50.39px;\n            color: #1c2640;\n            text-align: center;\n            margin: 0 0 80px;\n            padding: 0;\n        }\n        .sectionSix-sub-head{\n            font-family: Roboto;\n            font-size: 20px;\n            font-weight: 400;\n            line-height: 15px;\n            text-align: center;\n            color: #52667C;\n            margin-top: -60px;\n            margin-bottom: 50px;\n        }\n        .sectionSix-content{\n            height: 650px;\n            background: url('../../../resources/homepage/fold6_bg.png') no-repeat\n                bottom right;\n            background-size: 100%;\n\n            #sectionSix-left-middle {\n                display: flex;\n                flex-direction: row;\n                padding: 10px 110px;\n                width: 50%;\n            }\n\n            #sectionSix-left-middle-left {\n                text-align: left;\n                padding-right: 3%;\n                border-right: unset !important;\n                font-family: Roboto;\n                font-style: normal;\n                font-weight: normal;\n                font-size: 18px;\n                line-height: 26px;\n                color: #1c2640;\n                padding-right: 100px;\n\n                ul.list-delivers{\n                    margin: 0;\n                    list-style-type: none;\n                    li{\n                        margin-top: 20px;\n                        display: flex;\n                        \n                        .check-icon{\n                            width: 20px;\n                            height: 20px;\n                            margin-right: 10px;\n                            margin-top: 7.5px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
